export enum PasswordInputType {
  PASSWORD = 'password',
  TEXT = 'text',
}
